import { io } from "socket.io-client"
import { useRuntimeConfig } from "src/services/RuntimeConfig"

const runtimeConfig = useRuntimeConfig()

// TODO
const URL = runtimeConfig.API_WEBSOCKET_URL || ""
export const socket = io(URL, { autoConnect: false, transports: ["websocket"] })
